// wrapper to remount Jotai store on logout
import { createContext, useContext, useState, ReactNode } from 'react';
import { Provider as JotaiProvider } from 'jotai';

type AuthCtx = { logout: () => void };

const AuthContext = createContext<AuthCtx | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [storeKey, setStoreKey] = useState(0);

  const logout = () => {
    /* ← your sign-out API call, token clearing, etc. */
    setStoreKey(k => k + 1);            // ► remount Jotai store
  };

  return (
    <AuthContext.Provider value={{ logout }}>
      <JotaiProvider key={storeKey}>
        {children}
      </JotaiProvider>
    </AuthContext.Provider>
  );
}

// nice helper so you never forget the null-check
export function useLogout() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useLogout must be inside <AuthProvider>');
  return ctx.logout;
}
